import {
  AMEND_LOAN_REQUESTS_ERROR,
  AMEND_LOAN_REQUESTS_START,
  AMEND_LOAN_REQUESTS_SUCCESS,
} from 'constants/action-types/loanRequests/amendLoanRequests';
import notification from 'helpers/notificationHelper';
import apiAction from 'helpers/apiAction';

export default (organizationId, requestId, data) => (
  dispatch,
  onSuccess,
) =>
  dispatch(
    apiAction({
      url: `/organizations/${organizationId}/microloans/${requestId}/amend`,
      method: 'POST',
      data,
      API_REQUEST_START: AMEND_LOAN_REQUESTS_START,
      API_REQUEST_SUCCESS: AMEND_LOAN_REQUESTS_SUCCESS,
      API_REQUEST_FAILURE: AMEND_LOAN_REQUESTS_ERROR,
      callbackOnSuccess: ({ message }) => {
        onSuccess();
        notification({ message });
      },
      callbackOnFailure: ({ message }) =>
        notification({ message, status: 'error' }),
      onEnd: () => false,
    }),
  );
